import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import BudgetComponent from '../components/budget.component';
import { budgets } from '../../../../../../redux/fms/budgets/action';
import { selectBudgetsQueryItems } from '../../../../../../redux/fms/budgets/selector';
import { selectFinancialYearsListItems } from '../../../../../../redux/fms/financial-years/selector';
import { financialYears } from '../../../../../../redux/fms/financial-years/action';
import { selectDepartmentsListItems } from '../../../../../../redux/departments/selector';
import { departments } from '../../../../../../redux/departments/action';
import { projects } from '../../../../../../redux/projects/action';
import { selectListItems } from '../../../../../../redux/library/selector';

const ManagementBudget = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const budgetsQueryData = useSelector(selectBudgetsQueryItems)
  const libraryItemsData = useSelector(selectListItems)
  const financialYearsListData = useSelector(selectFinancialYearsListItems)
  const departmentsItemsData = useSelector(selectDepartmentsListItems)
  const projectsItemsData = useSelector(selectDepartmentsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectedBudgets, setSelectedBudgets] = useState<any>([])

  const fetchBudgetsQueryById = () => {
    dispatch(budgets.query({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/budgets/query`,
      entity: 'budgets',
      jsonData:
      {
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedBudgets({ ...selectedBudgets, [field]: event });
  }

  useEffect(() => {
    dispatch(financialYears.list({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/financial-years/list`,
      entity: 'financialYears',
      jsonData: {}
    })).then(() => {
      dispatch(departments.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/hrms/departments/list`,
        entity: 'departments',
        jsonData: {}
      }))
    }).then(() => {
      dispatch(projects.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/projects/list`,
        entity: 'projects',
        jsonData: {}
      }))
    }).then(() => {
      if (parmas?.id > 0) {
        fetchBudgetsQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, [])

  useEffect(() => {
    if (isQuery) {
      setSelectedBudgets(budgetsQueryData?.result?.items)
    }
  }, [isQuery])

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(budgets.resetAction({ actionType: 'update' }))
      await dispatch(budgets.update({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/budgets`,
        entity: 'budgets',
        jsonData:
        {
          Records: [
            {
              ...selectedBudgets
            }
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(budgets.resetAction({ actionType: 'create' }))
      await dispatch(budgets.create({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/budgets`,
        entity: 'budgets',
        jsonData:
        {
          Records: [
            {
              ...selectedBudgets
            }
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/fms/budgets')
  }

  return (
    <>
      {budgetsQueryData?.isLoading ? <PageLoader /> :
        <BudgetComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedBudgets={selectedBudgets}
          back={back}
          handleFormSubmit={handleFormSubmit}
          methodTypesList={libraryItemsData?.result?.BudgetMethodType}
          budgeTypesList={libraryItemsData?.result?.BudgetType}
          financialYearsList={financialYearsListData?.result?.items}
          departmentsList={departmentsItemsData?.result?.items}
          projectsList={projectsItemsData?.result?.items}
        />
      }
    </>
  )
}

export default ManagementBudget;